import LojaModel from "../../model/LojaModel";
import ProdutoModel from "../../model/ProdutoModel";
import C5ProdutoDAO from "../C5/C5ProdutoDAO";
import ObaBaseDAO from "./ObaBaseDAO";
import UsuarioModel from "../../model/UsuarioModel";

class ObaPromocaoDAO extends ObaBaseDAO {
  private static instance: ObaPromocaoDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ObaPromocaoDAO {
    if (!ObaPromocaoDAO.instance) {
      ObaPromocaoDAO.instance = new ObaPromocaoDAO();
    }
    return ObaPromocaoDAO.instance;
  }

  public async getPromocao(loja: LojaModel): Promise<ProdutoModel[]> {
    return this.get(
      `REQ_PROXY_PROMOCAO_${loja.lojaIdOba}`,
      `${this.endpoint}/promocao/${loja.lojaIdOba},SP`
    ).then((r: any) =>
      r.data.map((i: any) =>
        C5ProdutoDAO.getInstance().getBuscaProdutos(
          i.seqProduto,
          i.tipoDesconto,
          loja.lojaId
        )
      )
    );
  }

  public async getSemelhantes(
    sku: string,
    loja: LojaModel
  ): Promise<ProdutoModel[]> {
    return this.get(
      `REQ_PROXY_SEMELHANTE_${loja.lojaId}`,
      `${this.endpoint}/produto/prodSimilar/${sku}/${loja.lojaId}/${loja.uf}`
    ).then((r: any) =>
      r.data.map((i: any) =>
        C5ProdutoDAO.getInstance().getBuscaProdutos(
          i.seqproduto,
          i.tipoDesconto,
          loja.lojaId
        )
      )
    );
  }

  public async getCompreNovamente(
    loja: LojaModel,
    usuario: UsuarioModel
  ): Promise<ProdutoModel[]> {
    if (usuario.documento != null && usuario.documento.length === 0) {
      return Promise.resolve([]);
    }

    const compreNovamente: any = {
      nroempresa: loja.lojaId,
      uf: loja.uf,
      cpfCnpj: usuario.documento,
    };

    return this.post(
      `REQ_COMPRE_NOVAMENTE`,
      `${this.endpoint}/produto/compreNovamente`,
      compreNovamente
    ).then((r: any) =>
      r.data.map((i: any) =>
        C5ProdutoDAO.getInstance().getBuscaProdutos(
          i.seqproduto,
          i.tipoDesconto,
          loja.lojaId
        )
      )
    );
  }
}

export default ObaPromocaoDAO;
